import { Helmet } from "react-helmet-async";

const CourseSchema = ({ data }) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": data.name,
    "description": data.description,
    "url": data.url,
    "offers": {
      "@type": "Offer",
      "price": data.fee,
      "priceCurrency": "INR",
      "category": data.category
    },
    "provider": {
      "@type": "Organization",
      "name": "Agileseekers",
      "sameAs": "https://agileseekers.com"
    },
    "hasCourseInstance": {
      "@type": "CourseInstance",
      "courseMode": "Online",
      "courseWorkload": "PT10H"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
};

export default CourseSchema;
